/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * File: UserDropdown.tsx
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:02:25 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, Dropdown, Menu } from 'antd';
import { useNavigate } from 'react-router-dom';
import { InlineStylesModel } from '../../models/InlineStylesModel';

export enum MenuKeys {
  logout = 'Log Out',
  about = 'About',
  home = 'Home',
  profile = 'Profile'
}

const styles: InlineStylesModel = {
  dropDown: {
    cursor: 'pointer'
  },
  menu: {
    alignItems: 'center',
    background: 'none',
    borderRight: 'none',
    display: 'flex',
    marginLeft: '8px'
  },
  menuIcon: {
    color: 'rgb(132, 133, 154)',
    fontSize: '18px',
    marginLeft: '5px'
  }
};

export const UserDropdown = (): JSX.Element => {
  const { logout } = useAuth0();
  const navigate = useNavigate();

  const { user } = useAuth0();

  const handleAboutPage = (): void => {
    navigate(`/about`);
  };

  const menu = (
    <Menu disabledOverflow={true}>
      <Menu.Item onClick={handleAboutPage} key={MenuKeys.about}>
        {MenuKeys.about}
      </Menu.Item>
      <Menu.Item onClick={() => navigate('/profile')} key={MenuKeys.profile}>
        {MenuKeys.profile}
      </Menu.Item>
      <Menu.Item key={MenuKeys.logout} onClick={(): void => logout({})}>
        {MenuKeys.logout}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Avatar
        style={{ marginLeft: 8, cursor: 'pointer' }}
        src={user && user['https://acuity.mdsiinc.com/user/user_metadata'].profile_image_url ? user['https://acuity.mdsiinc.com/user/user_metadata'].profile_image_url : user?.picture}
      />
    </Dropdown>
  );
};
